import { LiveChat } from '@/components/chat/LiveChat';
import { Button } from '@/components/ui/button';
import { BookOpen } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Support() {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Support</h1>
        <Button onClick={() => navigate('/faq')} variant="outline">
          <BookOpen className="h-4 w-4 mr-2" />
          View Help Center
        </Button>
      </div>
      <LiveChat />
    </div>
  );
}
